import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { NavigateTeamsPageComponent } from "./navigate-teams-page.component";

export const navigateTeamsPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-navigate-teams-page", NavigateTeamsPageComponent)
    .atOrganisationUrl("/teams")
    .build();
